import Spinner from "shared/ui/Spinner";
import { StyledButton } from "./styled";

const ButtonAsLink = ({
  type = "button",
  disabled,
  loading,
  onClick,
  children,
  ...restProps
}) => {
  return (
    <StyledButton
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...restProps}
    >
      {loading ? (
        <>
          <Spinner /> Loading
        </>
      ) : (
        children
      )}
    </StyledButton>
  );
};

export default ButtonAsLink;
